window.$ = window.jQuery = require('jquery');
// require('jquery-migrate');
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
/**
 * Подключаем библиотеки
 */
// require('jquery-migrate/dist/jquery-migrate')
require('jquery-datetimepicker');
require('jquery-jeditable');
require('arcticModal');
require('velocity-animate')
jQuery.datetimepicker.setLocale('ru');
// require('noty');
require('readmore-js');
// require('fabric');
require('jcarousel/dist/jquery.jcarousel');
require('jcarousel/dist/jquery.jcarousel-control');
require('jcarousel/dist/jquery.jcarousel-pagination');
// require('jcarousel/dist/');
require('colpick-jQuery-Color-Picker/js/colpick');//требуется в редакторе
window.pako = require('pako');

require('jquery-validation');
window.LazyLoad = require('vanilla-lazyload/dist/lazyload');
// require('./../../public/assets-libs/blueimp/jQuery-File-Upload/js/vendor/jquery.ui.widget.js'); подключен в packages.json
// require('jquery.ui.widget');
// require('./../../public/assets-libs/blueimp/jQuery-File-Upload/js/jquery.iframe-transport.js');
// require('./../../public/assets-libs/blueimp/jQuery-File-Upload/js/jquery.fileupload.js');
